/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Popconfirm, Row, Space, Typography } from "antd";
import Table, { type ColumnsType } from "antd/lib/table";
import Title from "antd/lib/typography/Title";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { type PaginationParams } from "../../redux/slices/midservice/midserviceTypes";
// import AddUserForm from "./AddUserForm";
import {
  deletePacketConfigurationAsync,
  getConfigurationsListAsync,
  selectConfigurationCurrentPage,
  selectConfigurationsList,
  setCurrentPage,
} from "../../redux/slices/PacketConfiguration/PacketConfigurationSlice";
import { type PacketConfigurationResponseType } from "../../redux/slices/PacketConfiguration/PacketConfigurationTypes";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const ConfigurationPage: React.FC = () => {
  const configurationsList = useAppSelector(selectConfigurationsList);

  // const loading = useAppSelector(selectLoading);
  const dispatch = useAppDispatch();
  // const [filter, setFilter] = useState<Record<string, FilterValue | null>>({});
  // const [searchString, setSearchString] = useState<string>();
  const [pageSize, setPageSize] = useState(10);
  const page = useAppSelector(selectConfigurationCurrentPage);
  const navigate = useNavigate();
  // const [form] = Form.useForm();

  useEffect(() => {
    const paginationParams: PaginationParams = {
      page,
      limit: pageSize,
    };
    dispatch(getConfigurationsListAsync(paginationParams));
  }, []);

  const columns: ColumnsType<PacketConfigurationResponseType> = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              navigate(`/admin/configuration/${record?.id ?? "unknown"}`);
            }}
          >
            {text}
          </Button>
        </Space>
      ),
    },
    {
      title: "Домен",
      dataIndex: "domain",
      key: "domain",
    },
    {
      title: "Устройства",
      dataIndex: "instances",
      key: "instances",
      render: (text, record, index) => {
        if (record.instances == null) return "-";
        if (record.instances.length > 3) {
          return (
            <Text>
              {`${record.instances.slice(0, 3).join(", ")}...(${
                record.instances.length
              })`}{" "}
            </Text>
          );
        }
        return <Text>{record.instances.join(", ")}</Text>;
      },
    },
    {
      title: "Принято",
      dataIndex: "receivedConfigsAmount",
      key: "receivedConfigsAmount",
      render: (text, record, index) => {
        // const progress = Math.round(
        //   (record.receivedConfigsAmount ?? 0 / record.instances.length) * 100,
        // );
        return `${record.receivedConfigsAmount ?? 0}/${
          record.instances?.length ?? 0
        }`;
      },
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Управление",
      key: "action",
      fixed: "right",
      width: 100,

      render: (_, record) => (
        <>
          <Popconfirm
            okText={"Да"}
            cancelText={"Отменить"}
            title="Удалить конфигурацию?"
            onConfirm={async () =>
              await dispatch(deletePacketConfigurationAsync(record.id))
            }
          >
            <DeleteOutlined style={{ color: "#f5222d" }} />
          </Popconfirm>
        </>
      ),
    },
  ];

  // const onPaginationChange = (newPage: number, newPageSize: number) => {
  //   console.log('pagination', newPage, newPageSize)
  //   setPage(newPage)
  //   setPageSize(newPageSize)
  // }

  // const filtersToQueryString = (
  //   filters: Record<string, FilterValue | null>,
  // ): string => {
  //   let filterString: string = "";
  //   for (const [key, value] of Object.entries(filters)) {
  //     if (value == null) {
  //       continue;
  //     }
  //     if (filterString !== "") {
  //       filterString += "-";
  //     }

  //     filterString += `${key}*${String(value)}`;
  //   }

  //   return filterString;
  // };

  const onTableChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any,
  ): void => {
    console.log("onTableChange", pagination, filters, sorter, extra);

    const paginationParams: PaginationParams = {
      page: pagination.current,
      limit: pagination.pageSize,
      // filter: filtersToQueryString(filters),
      // search: searchString,
    };
    dispatch(getConfigurationsListAsync(paginationParams));

    dispatch(setCurrentPage(pagination.current));
    setPageSize(pagination.pageSize);
    // setFilter(filters);
    console.log("filterss", filters);
  };

  return (
    <>
      <Row>
        <Col flex="auto">
          <Title level={3}>Управление пакетными конфигурациями</Title>
        </Col>
        <Col span={6} offset={1} flex="none">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            href="/admin/configuration/new"
          >
            Добавить конфигурацию
          </Button>
        </Col>
      </Row>
      <Divider />

      <Table
        size="small"
        onChange={onTableChange}
        pagination={{
          // onChange: onPaginationChange,
          showSizeChanger: true,
          pageSize: configurationsList.pageSize,
          total: configurationsList.totalRecord,
          current: page,
        }}
        scroll={{ x: true }}
        columns={columns}
        dataSource={configurationsList.content}
      />
    </>
  );
};

export default ConfigurationPage;
